import { useTranslations } from '@vocab/react';
import { Text, Dropdown, Box, Stack, ContentBlock } from 'braid-design-system';
import { useAtomValue } from 'jotai';

import type { Country } from '../../../entities/Country';
import translations from '../../../locales.vocab';
import { maintenanceOnlineBankingMediumAtom } from '../../../usecases/Maintenance/MaintenanceStore';
import {
  banksOptionAtom,
  invalidBankAtom,
  selectedBankingOptionAtom,
} from '../../../usecases/OnlineBanking/OnlineBankingStore';

interface Props {
  handleOnChangeOnlineBanking: (event: any) => void;
  country: Country;
}

const OnlineBankingComponent = ({
  country,
  handleOnChangeOnlineBanking,
}: Props) => {
  const { t } = useTranslations(translations);
  const banksOption = useAtomValue(banksOptionAtom);
  const selectedBankingOption = useAtomValue(selectedBankingOptionAtom);
  const invalidBank = useAtomValue(invalidBankAtom);
  const maintenanceOnlineBankingMedium = useAtomValue(
    maintenanceOnlineBankingMediumAtom,
  );

  const renderSupportedBanks = () =>
    banksOption.map((bank) => (
      <option
        key={bank.value}
        value={bank.value}
        disabled={Boolean(maintenanceOnlineBankingMedium?.includes(bank.value))}
      >
        {bank.bankname}
      </option>
    ));

  return (
    <Box>
      <Stack space="medium">
        <ContentBlock width="xsmall" align="left">
          <Dropdown
            id="onlineBankingDropdown"
            label={t('select.a.bank')}
            placeholder={t('select.a.bank.placeholder')}
            onChange={handleOnChangeOnlineBanking}
            value={selectedBankingOption}
            tone={
              selectedBankingOption === '' && invalidBank
                ? 'critical'
                : 'neutral'
            }
            message={
              selectedBankingOption === '' &&
              invalidBank &&
              t('idVirtualAccount.select.a.bank.error')
            }
          >
            {renderSupportedBanks()}
          </Dropdown>
        </ContentBlock>
        {country === 'ID' && (
          <>
            <Text size="small" tone="secondary">
              {t('pay.option.idOnlineBanking.description2')}{' '}
              <b>{t('pay.option.idOnlineBanking.description3')}</b>
            </Text>

            <Text size="small" tone="secondary">
              {t('pay.option.idOnlineBanking.enhance.description1')}
            </Text>

            <Text size="small" tone="secondary">
              {t('pay.option.idOnlineBanking.enhance.description2')}
            </Text>

            <Text size="small" tone="secondary">
              {t('pay.option.idOnlineBanking.enhance.description3')}
            </Text>
          </>
        )}
        {(country === 'TH' || country === 'PH') && (
          <>
            <Text size="small" tone="secondary">
              {t('pay.option.thOnlineBanking.description1')}
            </Text>

            <Text size="small" tone="secondary">
              {t('pay.option.thOnlineBanking.description2')}
            </Text>
          </>
        )}
      </Stack>
    </Box>
  );
};

export default OnlineBankingComponent;
